export default { sha: '818a25e08cbf9c7c1e6f3a063c7419468ca997ea', buildNumber: 'undefined' }
